export default ({ cacheMap, preloadPiecesAmount, piecesInOneRow }) => {
  // Keep the active reader even before that piece receives its first bytes.
  // Otherwise the compact cache map filters the streamed piece out entirely.
  const cacheMapWithoutEmptyBlocks = cacheMap.filter(({ percentage, isReader }) => percentage > 0 || isReader)
  const columns = Math.max(1, Math.floor(Number(piecesInOneRow)) || 1)
  const requestedBlocks = Math.max(1, Math.floor(Number(preloadPiecesAmount)) || 1)

  // The mini map shows at least the configured preload buffer and grows with actually cached pieces.
  // Round the result to complete rows and never use the full cache capacity as the preview size.
  const visibleBlocks = Math.max(requestedBlocks, cacheMapWithoutEmptyBlocks.length)
  const blocksInCompleteRows = Math.ceil(visibleBlocks / columns) * columns
  const extraBlocksAmount = Math.max(0, blocksInCompleteRows - cacheMapWithoutEmptyBlocks.length)

  const extraEmptyBlocksForFillingLine = extraBlocksAmount ? new Array(extraBlocksAmount).fill({}) : []

  return [...cacheMapWithoutEmptyBlocks, ...extraEmptyBlocksForFillingLine]
}
